// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePassword_wrapper__JRffm","createPassword":"CreatePassword_createPassword__DRDiw"};